import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import { filter, map, takeUntil } from 'rxjs/operators';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import * as i2 from '@angular/router';
import { NavigationEnd, RouterModule } from '@angular/router';

class BreadcrumbService {
    constructor(router) {
        this.router = router;
        this.router = router;
        const crumbs = this.createBreadcrumbs(this.router.routerState.root.snapshot);
        this.breadcrumb$ = new BehaviorSubject(crumbs);
        this.registerRouterEvents();
    }
    /**
     * get new breadcrumbs after route has been changed
     */
    get breadcrumbs() {
        const observable = new Observable((observer) => {
            const sub = this.breadcrumb$.subscribe(observer);
            return () => {
                sub.unsubscribe();
            };
        });
        return observable;
    }
    /**
     * register to router events
     */
    registerRouterEvents() {
        this.router.events.pipe(filter((event) => event instanceof NavigationEnd), map(() => this.createBreadcrumbs(this.router.routerState.root.snapshot)))
            .subscribe((breadcrumbs) => this.breadcrumb$.next(breadcrumbs));
    }
    /**
     * create breadcrumbs for path
     */
    createBreadcrumbs(route, url = '', name = '') {
        const breadCrumbs = [];
        const routeConfig = route.routeConfig || {};
        let nextUrl = '/';
        if (routeConfig.data && routeConfig.data.hasOwnProperty('breadcrumb')) {
            const label = this.resolveLabel(route);
            nextUrl = route.url.reduce((current, next) => {
                if (current.length === 0) {
                    return next.path;
                }
                return `${current}/${next.path}`;
            }, url);
            breadCrumbs.push({ path: nextUrl, label, data: routeConfig.data || {} });
        }
        if (route.firstChild) {
            breadCrumbs.push(...this.createBreadcrumbs(route.firstChild, nextUrl));
        }
        return breadCrumbs;
    }
    resolveLabel(route) {
        if (route.data.breadcrumb instanceof Function) {
            return route.data.breadcrumb(route);
        }
        return route.data.breadcrumb;
    }
}
BreadcrumbService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: BreadcrumbService, deps: [{ token: i2.Router }], target: i0.ɵɵFactoryTarget.Injectable });
BreadcrumbService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: BreadcrumbService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: BreadcrumbService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i2.Router }]; } });

class BreadcrumbComponent {
    constructor(breadcrumbService, activatedRoute) {
        this.activatedRoute = activatedRoute;
        this.breadcrumbService = breadcrumbService;
        this.breadcrumbs = [];
        this.destroy$ = new Subject();
    }
    ngOnInit() {
        this.breadcrumbService.breadcrumbs
            .pipe(takeUntil(this.destroy$))
            .subscribe((breadcrumbs) => {
            this.breadcrumbs = breadcrumbs;
            const snapshot = this.activatedRoute.snapshot;
        });
    }
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
        this.destroy$ = null;
    }
}
BreadcrumbComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: BreadcrumbComponent, deps: [{ token: BreadcrumbService }, { token: i2.ActivatedRoute }], target: i0.ɵɵFactoryTarget.Component });
BreadcrumbComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: BreadcrumbComponent, selector: "aihub-breadcrumb", ngImport: i0, template: "<ul class=\"list breadcrumb-list\">\n  <li *ngFor=\"let item of breadcrumbs; let last = last\" class=\"breadcrumb-list--item\">\n    <ng-container *ngIf=\"last\">\n      {{item.label}}\n    </ng-container>\n    <ng-container *ngIf=\"!last\">\n      <a [routerLink]=\"[item.path]\" routerLinkActive=\"router-link-active\">{{item.label}}</a>\n    </ng-container>\n  </li>\n</ul>", styles: [":host{display:block}:host .breadcrumb-list{display:flex;list-style-type:none;margin:0;padding:0}:host .breadcrumb-list .breadcrumb-list--item{font-family:OpenSansBold;font-size:14px;color:#00a3e0}:host .breadcrumb-list .breadcrumb-list--item:not(:last-child):after{content:\"/\";margin:0 5px}:host .breadcrumb-list .breadcrumb-list--item:last-child{color:#0076a8}\n"], directives: [{ type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo", "routerLink"] }, { type: i2.RouterLinkActive, selector: "[routerLinkActive]", inputs: ["routerLinkActiveOptions", "routerLinkActive"], outputs: ["isActiveChange"], exportAs: ["routerLinkActive"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: BreadcrumbComponent, decorators: [{
            type: Component,
            args: [{ selector: 'aihub-breadcrumb', template: "<ul class=\"list breadcrumb-list\">\n  <li *ngFor=\"let item of breadcrumbs; let last = last\" class=\"breadcrumb-list--item\">\n    <ng-container *ngIf=\"last\">\n      {{item.label}}\n    </ng-container>\n    <ng-container *ngIf=\"!last\">\n      <a [routerLink]=\"[item.path]\" routerLinkActive=\"router-link-active\">{{item.label}}</a>\n    </ng-container>\n  </li>\n</ul>", styles: [":host{display:block}:host .breadcrumb-list{display:flex;list-style-type:none;margin:0;padding:0}:host .breadcrumb-list .breadcrumb-list--item{font-family:OpenSansBold;font-size:14px;color:#00a3e0}:host .breadcrumb-list .breadcrumb-list--item:not(:last-child):after{content:\"/\";margin:0 5px}:host .breadcrumb-list .breadcrumb-list--item:last-child{color:#0076a8}\n"] }]
        }], ctorParameters: function () { return [{ type: BreadcrumbService }, { type: i2.ActivatedRoute }]; } });

class AiHubBreadcrumbModule {
}
AiHubBreadcrumbModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AiHubBreadcrumbModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AiHubBreadcrumbModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AiHubBreadcrumbModule, declarations: [BreadcrumbComponent], imports: [CommonModule,
        RouterModule], exports: [BreadcrumbComponent, RouterModule] });
AiHubBreadcrumbModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AiHubBreadcrumbModule, providers: [], imports: [[
            CommonModule,
            RouterModule
        ], RouterModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: AiHubBreadcrumbModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        RouterModule
                    ],
                    providers: [],
                    declarations: [BreadcrumbComponent],
                    exports: [BreadcrumbComponent, RouterModule]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AiHubBreadcrumbModule, BreadcrumbComponent, BreadcrumbService };
